import { DirectionsWalk } from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText, styled, Switch } from '@mui/material';
import { SettingsListItemText } from 'components/Settings/SettingsListItemText';
import { SettingsListSubheader } from 'components/Settings/SettingsListSubheader';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';
import { SETTINGS_ITEM_MAX_WIDTH } from 'themes/constants';

interface StepCountSettingsProps {
  stepCountTaskEnabled: boolean;
}
const StyledListItem = styled(ListItem)(({ theme }) => ({
  maxWidth: SETTINGS_ITEM_MAX_WIDTH,
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(4),
  },
}));

const FootNoteListItem = styled(ListItem)(({ theme }) => ({
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    marginTop: 0,
  },
}));
const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    maxWidth: '70%',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    maxWidth: '60%',
  },
}));
// TODO: translate the strings in this component: https://wellframe.atlassian.net/browse/WFMOB-14122
export const StepCountSettings = ({ stepCountTaskEnabled }: StepCountSettingsProps) => {
  const { isDesktop } = useDeviceType();
  const { translation } = useTranslationContext();
  return (
    <List aria-labelledby="stepCountSettings__step-count-task-settings">
      <SettingsListSubheader isDesktop={isDesktop} aria-label={translation('step_count')}>
        {translation('step_count_settings')}
      </SettingsListSubheader>
      <StyledListItem aria-labelledby="settings__step-count-settings" divider={isDesktop}>
        <ListItemIcon>
          <DirectionsWalk color="secondary" />
        </ListItemIcon>
        <StyledListItemText
          id="stepCountSettings__step-count-task-settings"
          primary={translation('checklist_step_tracker')}
          secondary={translation('checklist_step_tracker_summary')}
        />
        <Switch
          edge="end"
          disabled
          checked={stepCountTaskEnabled}
          inputProps={{
            'aria-checked': stepCountTaskEnabled,
            'aria-labelledby': 'stepCountSettings__step-count-task-settings',
          }}
        />
      </StyledListItem>
      <FootNoteListItem aria-labelledby="stepCountSettings__step-count-settings-footnote">
        <SettingsListItemText
          inset={!isDesktop}
          id="stepCountSettings__step-count-settings-footnote"
          primaryTypographyProps={{ variant: 'body2' }}
          primary={translation('web_step_count_setting_text')}
        />
      </FootNoteListItem>
    </List>
  );
};
